export default function filePromise(file) {
  if ((file instanceof File || file instanceof Blob) == false)
    throw new TypeError(
      "Invalid type of argument file. The argument must be a instanceof File or Blob"
    );

  return new Promise((resolve, reject) => {
    var fr = new FileReader();
    fr.onload = () => {
      resolve({ fileReader: fr, file });
    };
    fr.readAsDataURL(file);
  });
}
